import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EnderPostal } from "../../../interfaces/entities/MeuCadastro/EnderPostal";
import "./styles.css";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import ModalEditAdress from "./ModalEditAdress/ModalEditAdress";

const AdressData: React.FC<{ enderPostal: EnderPostal[]; handleEdit: () => void; canChangeData: boolean; 
  openModalSuccessNoButton: () => void; }> = ({ enderPostal, canChangeData, openModalSuccessNoButton }) => {

  const { textStyleAccessibility, calculateTextStyle, contrastStyle, contrastBorderAccessibility } = useAccessibility();
  const font14Style = calculateTextStyle(14)
  const [showModalEdit, setShowModalEdit] = useState<boolean>(false);

  const endereco = enderPostal.find(endereco => {
    return endereco.tipo === 'RESIDENCIAL';
  });

  const handleEdit = () => {
    setShowModalEdit(true)
  }
  
  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card" style={{ ...contrastBorderAccessibility, ...contrastStyle }}>
        <div className="registration-data-row">
          <span style={textStyleAccessibility} className="registration-data-title">Dados de endereço de correspondência</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{ ...contrastBorderAccessibility, ...contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Logradouro</span>
          <span style={font14Style} className="registration-data-value">{endereco?.logradouro}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Número</span>
          <span style={font14Style} className="registration-data-value">{endereco?.numero}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{ ...contrastBorderAccessibility, ...contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Complemento</span>
          <span style={font14Style} className="registration-data-value">{endereco?.complemento || '-'}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Bairro</span>
          <span style={font14Style} className="registration-data-value">{endereco?.bairro}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{ ...contrastBorderAccessibility, ...contrastStyle }}>
          <span style={font14Style} className="registration-data-key">CEP</span>
          <span style={font14Style} className="registration-data-value">{endereco?.cep}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Cidade</span>
          <span style={font14Style} className="registration-data-value">{endereco?.cidade}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary radius-bottom" style={{ ...contrastBorderAccessibility, ...contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Estado</span>
          <span style={font14Style} className="registration-data-value">{endereco?.estado}</span>
        </div>
      </div>
      {canChangeData &&
        <button
          style={{ ...textStyleAccessibility }}
          className="edit-registration-data"
          onClick={handleEdit}>
          <FontAwesomeIcon icon={faEdit} /> <u>Alterar dados do endereço de correspondência</u>
        </button>
      }
      <ModalEditAdress
        open={showModalEdit}
        onClose={() => setShowModalEdit(false)}
        enderPostal={enderPostal}
        tipoEndereco={endereco?.tipo}
        openModalSuccessNoButton={openModalSuccessNoButton}
        title={'Alterar endereço de correspondência'}
      />
    </div>
  )
}

export default AdressData;